export const queryKeys = {
  user: "user-orbis-dashboard",
  partner: "partner-orbis-dashboard",
};
